export const CrossSellLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
    CROSS_SELL_INVALID_ACTION: 'CROSS_SELL_INVALID_ACTION',
};
